// For Repository Workflow
import type { AsyncData } from '#app';
import type { IModelResponse } from '~/services/base/dto/base.dto';
import type { IModelGETWorkflowRuntimeIdResponse, IModelGETWorkflowRuntimeRequest, IModelPOSTWorkflowRuntimeRequest, IModelPUTWorkflowRuntimeRequest, ModelGETWorkflowRuntime } from './dto/workflow.dto';

export class WorkflowRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getWorkflowRuntime(params: IModelGETWorkflowRuntimeRequest): Promise<AsyncData<IModelResponse<ModelGETWorkflowRuntime[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/workflow-runtime`, this.configService, {
      params
    });
    return dataResult;
  }

  async getWorkflowRuntimeId(id: string | number): Promise<AsyncData<IModelResponse<IModelGETWorkflowRuntimeIdResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/workflow-runtime/${id}`, this.configService);
    return dataResult;
  }
}
